import { WikiLayout } from "@/components/WikiLayout";
import { WikiPage } from "@/components/WikiPage";
import { Link } from "react-router-dom";

const OnboardingWelcome = () => {
  return (
    <WikiLayout>
      <WikiPage 
        title="Welcome to BlueLux Pool Service" 
        description="Your journey to excellence starts here"
      >
        <section className="space-y-6">
          <p>
            Welcome to BlueLux Pool Service! We're excited to have you join our team of professional 
            pool service technicians. This wiki is your central resource for everything you need to 
            know to succeed as an independent contractor with BlueLux.
          </p>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Why BlueLux is Different</h2>
          <p>
            At BlueLux, we're building something special: a pool service company where quality comes first,
            customers are treated like family, and technicians are rewarded for excellence.
          </p>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li>Industry-leading compensation with performance bonuses</li>
            <li>Flexible schedule as an independent contractor</li>
            <li>Supportive team environment with ongoing training</li>
            <li>Focus on quality over quantity</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Your First Steps</h2>
          <p>Here's what you need to do to get started:</p>
          <ul className="list-disc list-inside space-y-2 text-muted-foreground">
            <li><Link to="/wiki/onboarding/first-day" className="text-primary hover:underline">Review the First Day Guide</Link> - Know what to expect and how to prepare</li>
            <li><Link to="/wiki/onboarding/training" className="text-primary hover:underline">Understand the Training Program</Link> - Learn our 3-phase approach</li>
            <li><Link to="/wiki/compensation/pay-incentives" className="text-primary hover:underline">Review Pay & Incentives</Link> - Understand your base pay and bonuses</li>
            <li><Link to="/wiki/resources/contacts" className="text-primary hover:underline">Save Key Contacts</Link> - Know who to reach out to</li>
          </ul>

          <h2 className="text-2xl font-semibold text-foreground mt-8 mb-4">Our Mission</h2>
          <p className="text-lg italic text-muted-foreground border-l-4 border-primary pl-4">
            "To provide exceptional pool care that transforms backyard pools into pristine, 
            worry-free retreats for families throughout San Diego County."
          </p>
        </section>
      </WikiPage>
    </WikiLayout>
  );
};

export default OnboardingWelcome;